import { render, staticRenderFns } from "./ServiceDetails.vue?vue&type=template&id=d1c98810&scoped=true&"
import script from "./ServiceDetails.vue?vue&type=script&lang=js&"
export * from "./ServiceDetails.vue?vue&type=script&lang=js&"
import style0 from "./ServiceDetails.vue?vue&type=style&index=0&id=d1c98810&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1c98810",
  null
  
)

export default component.exports